<template>
    <section class="bg-white py-8 px-6">
        <div
            class="max-w-7xl mx-auto bg-black rounded-3xl p-6 md:p-10 lg:p-12 flex flex-col lg:flex-row items-center justify-between gap-6">
            <div class="text-white text-center lg:text-left">
                <h2 class="text-2xl md:text-3xl font-bold">Baixe Nossos Aplicativos</h2>
                <p class="mt-2 text-sm md:text-base text-gray-300">
                    Acesse todas as nossas soluções diretamente do seu dispositivo e<br class="hidden sm:inline" />
                    gerencie seu negócio de qualquer lugar.
                </p>
            </div>
            <div class="flex flex-wrap justify-center lg:justify-end gap-4">
                <a href="https://play.google.com/store/apps/developer?id=OVER+X+TECNOLOGIA+LTDA&hl=pt_BR"
                    class="flex items-center gap-2 border border-[#FF7A00] bg-white text-black py-2 px-4 rounded-lg text-sm font-medium shadow hover:shadow-md transition">
                    <img src="https://cdn-icons-png.flaticon.com/512/888/888857.png" alt="Play Store" class="h-5 w-5">
                    <span>Baixe aqui no<br><b>Play Store</b></span>
                </a>
                <a href="https://apps.apple.com/br/developer/over-x-tecnologia-ltda/id1751007660"
                    class="flex items-center gap-2 border border-[#FF7A00] bg-white text-black py-2 px-4 rounded-lg text-sm font-medium shadow hover:shadow-md transition">
                    <img src="https://cdn-icons-png.flaticon.com/512/831/831276.png" alt="App Store" class="h-5 w-5">
                    <span>Baixe aqui na<br><b>App Store</b></span>
                </a>
                <a href="https://marketplace.overx.com.br/search"
                    class="flex items-center gap-2 border border-[#FF7A00] bg-white text-black py-2 px-4 rounded-lg text-sm font-medium shadow hover:shadow-md transition">
                    <img src="https://cdn-icons-png.flaticon.com/512/8330/8330696.png" alt="Notebook" class="h-5 w-5">
                    <span>Acesse pelo<br><b>Desktop</b></span>
                </a>
            </div>
        </div>
    </section>
</template>
